'use client';
import Link from '@/components/WrappedLink';
import {
    Ar200,
    Ar7,
    Ar90,
    ArPercentage,
    En200,
    En7,
    En90,
    EnPercentage,
} from '../../../../public/Images';
import { AVAILABLE_LANGUAGES } from '@/constants';
import myImageLoader from '@/image.local.loader';

interface IValuePropositionDesktopProps {
    lang: AVAILABLE_LANGUAGES;
}
const ValuePropositionDesktop = ({ lang }: IValuePropositionDesktopProps) => {
    const imgs =
        lang === AVAILABLE_LANGUAGES.ar
            ? [ArPercentage, Ar7, Ar90, Ar200]
            : [EnPercentage, En7, En90, En200];

    return (
        <div
            className={
                'border-gray-200 py-6 border-t border-b border-solid lg:py-0 lg:border-0'
            }
        >
            <div className={'gap-2 flex w-full justify-start mt-2 lg:mt-0'}>
                {imgs?.map((img, index) => {
                    return (
                        <Link
                            key={img.src + index}
                            className={'flex w-1/4 '}
                            href={`/${lang}/why-sylndr`}
                        >
                            <img
                                src={myImageLoader({
                                    src: img.src,
                                    width: 636,
                                    height: 860,
                                    quality: 75,
                                })}
                                loading={'lazy'}
                                fetchPriority={'low'}
                                alt={'value ' + index}
                                className={
                                    'object-contain inline-block cursor-pointer box-border p-0 rounded-[4%] w-[45vw] max-w-[45vw] h-auto lg:w-full lg:max-w-full'
                                }
                            />
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default ValuePropositionDesktop;
